import { Button, Description, Label } from '@heroui/react';
import { formatDateOnlyBR } from '../../../utils/date-utils';
import {
  AVAILABLE_SPOTS_PERIOD_PRESETS,
  computeAvailableSpotsPeriodPresetRange,
  type AvailableSpotsPeriodPresetId,
  type AvailableSpotsPeriodSelection,
} from '../utils/available-spots-period-presets';

interface AvailableSpotsPeriodPresetsProps {
  selectedPresetId: AvailableSpotsPeriodSelection;
  startDate: string;
  endDate: string;
  onSelectPreset: (presetId: AvailableSpotsPeriodPresetId, startDate: string, endDate: string) => void;
}

export function AvailableSpotsPeriodPresets({
  selectedPresetId,
  startDate,
  endDate,
  onSelectPreset,
}: AvailableSpotsPeriodPresetsProps) {
  return (
    <section className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <Label className="text-base font-semibold">Período rápido</Label>
        <Description>Escolha um intervalo pré-definido a partir de hoje.</Description>
      </div>

      <div className="flex flex-wrap gap-2">
        {AVAILABLE_SPOTS_PERIOD_PRESETS.map((preset) => (
          <Button
            key={preset.id}
            size="sm"
            variant={selectedPresetId === preset.id ? 'primary' : 'secondary'}
            onPress={() => {
              const range = computeAvailableSpotsPeriodPresetRange(preset.id);
              onSelectPreset(preset.id, range.startDate, range.endDate);
            }}
          >
            {preset.label}
          </Button>
        ))}
      </div>

      <Description className="text-center text-xs">
        De <strong>{formatDateOnlyBR(startDate)}</strong> até{' '}
        <strong>{formatDateOnlyBR(endDate)}</strong>
      </Description>
    </section>
  );
}
